import View from "../framework/view";

/**
 * A HashUrl is the part of the hash excluding the leading # (and starting with / according to the conventions in this app)
 */
export type HashUrl = string;

/**
 * Pug templates
 */
export type Template = (locals: any) => string;

export interface FunctionBadge {
    fn: AppFunction,
    green?: number;
    orange?: number;
    red?: number;
}

export function badgeChange(last: FunctionBadge | undefined, now: FunctionBadge) {
    if (last == undefined) {
        return true;
    }
    return last.green != now.green || last.orange != now.orange || last.red != now.red;
}

export type BadgeListener = (b: FunctionBadge) => void;

/**
 * Represents a function that can be displayed in the main pane of the application.
 * A function has a representation as a hash-URL (so functions can be loaded directly via URL)
 */
export abstract class AppFunction {

    abstract view(): View;

    abstract url(): HashUrl;

    isRoot(): boolean {
        return false;
    }

    /**
     * @return true if the function has "zero" navigation (eg, login page)
     */
    isZero(): boolean {
        return false;
    }

    /**
     * Override to return a custom page template
     */
    pageTemplate() : Template | undefined {
        return undefined;
    }

    /**
     * Most functions aren't available offline. Subclasses can override this to indicate that they
     * are offline enabled.
     */
    offlineEnabled() : boolean {
        return false;
    }

    /**
     * Functions can be "cacheable", which means that new instances are not created each time the
     * URL is visited. This is good for maintaining model state.
     */
    isCacheable() {
        return false;
    }

    refresh() {
        // NOP
    }
}

export type JsonDate = string; // yyyy-mm-dd

export type AusDollar = number;

export type AusCents = number;

export const NOTE_TO_FLORIST = "Note to florist/special requirements";

const customFieldOrder : { [title: string] : number } = {
    NOTE_TO_FLORIST: 1,
    "Pick up or delivery date:": 2
};

interface CustomField {
    title: string,
    value: string
};

const customFieldsComparator : ((a: CustomField, b:CustomField) => number) = ((a, b) => {
    const a1 = customFieldOrder[a.title] || 9999;
    const b1 = customFieldOrder[b.title] || 9999;
    return a1 == b1 ? 0 : ( a1 < b1 ? -1 : 1 );
});

export const customFieldsSorter : ((a: CustomField[]) => CustomField[]) = a => a.sort(customFieldsComparator);

export const ROLE_ADMIN = "Admin";
export const ROLE_FLORIST = "Florist";
export const ROLE_DELIVERY = "Delivery";
export const ROLE_CASUAL_DELIVERY = "Casual Delivery";
export const ROLE_NONE = "None";

export type Role = "Admin" | "Florist" | "Delivery" | "Casual Delivery" | "None";

export const roles = [
    ROLE_ADMIN,
    ROLE_FLORIST,
    ROLE_DELIVERY,
    ROLE_NONE
];

export function viewOrderDetails(role: Role | undefined) : boolean {
    const ok = {
        "Admin" : true,
        "Florist" : true,
    }
    // @ts-ignore
    return ok[role];
}

export function canEditOrder(role: Role | undefined) : boolean {
    const ok = {
        "Admin" : true,
        "Florist" : true,
    }
    // @ts-ignore
    return ok[role];
}

export function canViewOrderSession(role: Role | undefined) : boolean {
    const ok = {
        "Admin" : true,
    }
    // @ts-ignore
    return ok[role];
}

export type DeliveryTime = string;

